import React from 'react';
import './Header.scss';
import {motion} from 'framer-motion';
import {images} from '../../constants';

import {AppWrap} from '../../wrapper';



const scaleVariants = {
  whileInView: {scale: [0, 1],opacity: [0, 1], transition: {duration: 1, ease: 'easeInOut'}}
};

const Header = () => {
  return (
    // using HOC so div nolonger need id
    <div  className='app__header app__flex'>
      <motion.div 
        whileInView={{x: [-100, 0], opacity: [0, 1], transition: {duration: 1.5}}}
        transition={{duration: 0.5}}
        className='app__header-info'
      >
        <div className='app__header-badge'>
          <div className='badge-cmp app__flex'>
            <span>👋</span>
            <div style={{marginLeft: 20}}>
              <p className='p-text'>Hello, I am</p>
              <h1 className='head-text'>Hanhz</h1>
            </div>
          </div>
          <div className='tag-cmp app__flex' style={{textTransform:'uppercase'}}>
            <p className='tag-text'> Frontend Developer</p>
            <p className='tag-text'> UI/UX Designer</p>
          </div>

          <div className='tag-cmp app__flex'>
            <p className='tag-text'>I'm working for <a href="https://metatavu.fi/" target="_blank">🏢Metatavu</a> as a Software Engineere internship</p>
          </div>

        </div>

      </motion.div>
      <motion.div 
        whileInView={{opacity: [0, 1]}}
        transition={{duration: 0.5, delayChildren: 0.5}}
        className='app__header-img'>
        <img src={images.profile3} alt='profile_bg' />
        <motion.img
          whileInView={{scale: [0, 1]}}
          transition={{duration: 1, ease: 'easeInOut'}}
          src={images.circle}
          alt='profile_circle'
          className='overlay_circle'
        />
      </motion.div>

      <motion.div
        variant={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className='app__header-circles'
      >
        {[images.redux, images.react, images.typescript, images.javascript, images.git].map((circle, index) => (
          <div className='circle-cmp app__flex' key={`circle-${index}`}>
            <img src={circle} alt="circle" />
          </div>
        ))}

      </motion.div>
    </div>
  );
};


export default AppWrap(Header, 'home');